/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Section_Ready_LeadInputs */

const en_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready when`)
};

const es_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo cuando`)
};

const de_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit,`)
};

const zh_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你准备好时，`)
};

const ar_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جاهزون عندما`)
};

const fr_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêts quand`)
};

const vi_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sẵn sàng khi`)
};

const sw_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuko tayari`)
};

const th_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`พร้อมเมื่อ`)
};

const bs_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spremni kad`)
};

const ja_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご準備ができたら、`)
};

const ko_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`준비되시면`)
};

const pt_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto`)
};

const it_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronti`)
};

const sv_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redo`)
};

const nl_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar`)
};

const da_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi er klar,`)
};

const nb_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vi er klare`)
};

const fi_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmiina, kun`)
};

const pl_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jesteśmy gotowi,`)
};

const ru_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мы готовы,`)
};

const tr_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siz hazır olduğunuzda`)
};

const hi_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब आप तैयार हों,`)
};

const id_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siap kapan pun`)
};

const ms_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sedia bila-bila masa`)
};

const cs_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jsme připraveni,`)
};

const el_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Είμαστε έτοιμοι`)
};

const he_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אנחנו מוכנים`)
};

const af_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ons is gereed`)
};

const hu_home_section_ready_lead = /** @type {(inputs: Home_Section_Ready_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Készen állunk,`)
};

/**
* | output |
* | --- |
* | "Ready when" |
*
* @param {Home_Section_Ready_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_section_ready_lead = /** @type {((inputs?: Home_Section_Ready_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Section_Ready_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_section_ready_lead(inputs)
	if (locale === "de") return de_home_section_ready_lead(inputs)
	if (locale === "zh") return zh_home_section_ready_lead(inputs)
	if (locale === "ar") return ar_home_section_ready_lead(inputs)
	if (locale === "fr") return fr_home_section_ready_lead(inputs)
	if (locale === "vi") return vi_home_section_ready_lead(inputs)
	if (locale === "sw") return sw_home_section_ready_lead(inputs)
	if (locale === "th") return th_home_section_ready_lead(inputs)
	if (locale === "bs") return bs_home_section_ready_lead(inputs)
	if (locale === "ja") return ja_home_section_ready_lead(inputs)
	if (locale === "ko") return ko_home_section_ready_lead(inputs)
	if (locale === "pt") return pt_home_section_ready_lead(inputs)
	if (locale === "it") return it_home_section_ready_lead(inputs)
	if (locale === "sv") return sv_home_section_ready_lead(inputs)
	if (locale === "nl") return nl_home_section_ready_lead(inputs)
	if (locale === "da") return da_home_section_ready_lead(inputs)
	if (locale === "nb") return nb_home_section_ready_lead(inputs)
	if (locale === "fi") return fi_home_section_ready_lead(inputs)
	if (locale === "pl") return pl_home_section_ready_lead(inputs)
	if (locale === "ru") return ru_home_section_ready_lead(inputs)
	if (locale === "tr") return tr_home_section_ready_lead(inputs)
	if (locale === "hi") return hi_home_section_ready_lead(inputs)
	if (locale === "id") return id_home_section_ready_lead(inputs)
	if (locale === "ms") return ms_home_section_ready_lead(inputs)
	if (locale === "cs") return cs_home_section_ready_lead(inputs)
	if (locale === "el") return el_home_section_ready_lead(inputs)
	if (locale === "he") return he_home_section_ready_lead(inputs)
	if (locale === "af") return af_home_section_ready_lead(inputs)
	if (locale === "hu") return hu_home_section_ready_lead(inputs)
	return en_home_section_ready_lead(inputs)
});